import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeRombus extends Shape {
    fitText(textPart: ShapeTextPart, x: number, y: number, width: number, height: number) {
        const k = (height * width) / (height + width);
        const allowedWidth = k;
        const allowedHeight = k;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x + width / 2, y);
        canv.ctx.lineTo(x, y + height / 2);
        canv.ctx.lineTo(x + width / 2, y + height);
        canv.ctx.lineTo(x + width, y + height / 2);
        canv.ctx.lineTo(x + width / 2, y);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="M0.707107 12.5L12.5 0.707107L24.2929 12.5L12.5 24.2929L0.707107 12.5Z"/>
            </svg>
        `;
    }
}
